var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}${_vm.slug}`,"viewBox":"0 0 12 12"}},[_c('polyline',{style:({
			transform: `rotate3d(0, 0, 1, ${_vm.angle}deg)`,
			transformOrigin: 'center',
		}),attrs:{"stroke":_vm.disabled ? _vm.colors.disabled : _vm.colors.main,"fill":"none","points":"3.5 1 8.5 6 3.5 11","stroke-miterlimit":"10"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }